import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=1e654b09&scoped=true&"
import script from "./Refresh.vue?vue&type=script&lang=js&"
export * from "./Refresh.vue?vue&type=script&lang=js&"
import style0 from "./Refresh.vue?vue&type=style&index=0&id=1e654b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e654b09",
  null
  
)

export default component.exports